import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeFact1 = ({autorizacUA, empresa, styles, handleClickSel1, handleClickSelPFDX,
                    handleClickSel5, handleClickSel6, handleClickSel8, handleClickEC, handleClickSel9,
                    handleClickOnepay, handleClickElimOnepay}) => {
  const a0501 = autorizacUA.findIndex( autorizac => autorizac === "0501" );
  const a0505 = autorizacUA.findIndex( autorizac => autorizac === "0505" );
  const a0510 = autorizacUA.findIndex( autorizac => autorizac === "0510" );
  const a0512 = autorizacUA.findIndex( autorizac => autorizac === "0512" );
  const a0513 = autorizacUA.findIndex( autorizac => autorizac === "0513" );
  const a0514 = autorizacUA.findIndex( autorizac => autorizac === "0514" );
  const a0515 = autorizacUA.findIndex( autorizac => autorizac === "0515" );
  const a0520 = autorizacUA.findIndex( autorizac => autorizac === "0520" );

  const a0503 = autorizacUA.findIndex( autorizac => autorizac === "0503" );

  let empresaOpc = "Enviar facturación por correo"
  if(empresa.empresaArchFE==="codisert"){
    empresaOpc = "Descargar pdf de facturas en servidor"
  }
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        FACTURACION
      </button>

      {a0501!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large share square violet icon"></i>
        Proceso de facturación
      </button>
      }

      {((empresa.empresaArchFE==="supercable")&&(a0503!==-1)) &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelPFDX}>
        <i className="large share square violet icon"></i>
        Proceso de facturación RET
      </button>
      }

      {a0505!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel5}>
        <i className="large print violet icon"></i>
        Imprimir facturación
        </button>
      }
      {a0510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel8}>
        <i className="large print violet icon"></i>
        Imprimir documentos de cobro
      </button>
      }

      {a0512!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickEC}>
            <i className="large indent violet icon"></i>
            {empresaOpc}
          </button>
        </div>
      }

      {a0513!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickOnepay}>
            <i className="large indent violet icon"></i>
            Enviar facturación a ONEPAY
          </button>
        </div>
      }
      {a0514!==-1 &&
        <div>
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickElimOnepay}>
            <i className="large indent violet icon"></i>
            Enviar ELIMINACION a ONEPAY
          </button>
        </div>
      }

      {a0515!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel6}>
            <i className="large indent violet icon"></i>
            Movimientos a facturar
          </button>
        </div>
      }

      {a0520!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel9}>
            <i className="large indent violet icon"></i>
            Rango
          </button>
        </div>
      }
    </div>
  )
};

export default HomeFact1
